module.exports = __webpack_public_path__ + "img/parter-logo-2.818ace9a.png";